import { BlocksIconBox } from 'blocks-nextjs/blocks-web-components/components/icon/icons/box';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconBox = createComponent({ react: React, tagName: 'cat-icon-box', elementClass: BlocksIconBox });
